import { QuestionGroupType } from '@exam-management/graphql';

import type { SingleQuestionCreationFormInput } from './single-question-creation.schema';

export function parseQuestionFormDataForApi(
  data: SingleQuestionCreationFormInput,
  parseContentForApi: (content: string) => string,
) {
  const isCalculated = data.information.calculated === 'true';
  const pValue = data.information.pValue.pInitial;

  const group = {
    type: QuestionGroupType.Single,
  };
  const cognitiveDomains = data.properties.cognitiveDomain
    ?.map((domain) => domain?.value)
    .filter((value) => typeof value === 'string');

  return {
    details: parseContentForApi(data.detail.details),
    choices: data.detail.choices.map((choice) => ({
      ...choice,
      label: parseContentForApi(choice.label),
    })),
    correctAnswer: data.detail.correctAnswer,
    calculated: isCalculated,
    pValue: pValue,
    cognitiveDomains,
    learningObjectiveStatement: data.properties.learningObjectiveStatement?.value as string,
    solution: parseContentForApi(data.properties.solution),
    reference: parseContentForApi(data.properties.reference),
    group,
  };
}
